const cleanUpParagraph = (value) =>
  //This Function is to remove the span that tag has the class hljs-...,
  //(that is sometimes added by the client)
  //inside the paragraph and keep the content inside it,
  //in order to render MathJax correctly
  value.replace(/<span\s[^>]*class="hljs-[^>]*>(.*?)<\/span>/g, "$1");

export default cleanUpParagraph;
